import { defineStore } from 'pinia';
import axiosInstance from '@/axios';
import urlList from '../../utils/apis.json';

export const useProjectStore = defineStore('projects', {
    state: () => ({
        dataList: null,
        dataProject: null
    }),

    actions: {
        getList(payload = null) {
            axiosInstance.defaults.headers.common['Authorization'] =
                `Bearer ${window.localStorage.getItem('token')}` || '';
            return axiosInstance
                .get(urlList['projects'], { ...payload })
                .then((res) => {
                    this.dataList = res;
                    return res;
                });
        },
        async getDetail(id) {
            try {
                await axiosInstance.get(`${urlList['projects']}/${id}`).then((res) => {
                    this.dataProject = res.data;
                    return res;
                });
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async add(formData) {
            try {
                return await axiosInstance.post(urlList['projects'], formData);
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async update(formData, id) {
            try {
                return axiosInstance.put(`${urlList['projects']}/${id}`, formData).then((res) => {
                    return res;
                });
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async delete(id) {
            try {
                const response = await axiosInstance.delete(`${urlList['projects']}/${id}`);
                return response;
            } catch (error) {
                console.error('Error:', error);
                throw error;
            }
        }
    },
    getters: {}
});
